<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M8.52825 9.14418C8.80163 9.35278 9.19837 9.35242 9.47212 9.14418L17.0351 3.38154C16.6702 3.14153 16.2277 3 15.7504 3H2.25C1.77225 3 1.32975 3.14189 0.96525 3.38154L8.52825 9.14418Z"
    />
    <path
      d="M17.8241 13.7033C17.9374 13.4505 18 13.1735 18 12.8826V5.11771C18 4.91406 17.9678 4.71782 17.9104 4.5311L11.8478 9.15053L17.8241 13.7033Z"
    />
    <path
      d="M0.0896251 4.5311C0.0322501 4.71746 0 4.91406 0 5.11771V12.8826C0 13.1735 0.062625 13.4509 0.175875 13.7033L6.15225 9.15018L0.0896251 4.5311Z"
    />
    <path
      d="M10.6556 10.0587L10.4156 10.2415C10.0058 10.5539 9.5025 10.7102 9 10.7102C8.4975 10.7102 7.99463 10.5539 7.58438 10.2412L7.34437 10.0583L1.18762 14.7483C1.50412 14.9086 1.86562 15 2.24962 15H15.7496C16.1336 15 16.4951 14.9086 16.8116 14.7483L10.6553 10.0583L10.6556 10.0587Z"
    />
  </svg>
</template>
